import requestReducer from '../requestReducer';
import Prepayment from '../../models/Prepayment';
import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'


export interface PrepaymentDetailState extends PaginatedApiState {
  prepayment?: Prepayment[]
}

const PrepaymentDetail = (state: PrepaymentDetailState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    case 'PREPAYMENT_CLEAR':
      {
      return { ...state, prepayment: null }
      }
    default:
      return requestReducer<PrepaymentDetailState>('PREPAYMENT_DETAIL')(state, action)
  }
}

export default PrepaymentDetail
